// extracted by mini-css-extract-plugin
module.exports = {"articleHeader":"ArticleHeader_articleHeader__3vAVJ","articleHeaderH2":"ArticleHeader_articleHeaderH2__2IOOW"};